module.exports = __webpack_public_path__ + "static/media/teamNavbar.b2b0fbdc.svg";